const tabNames = [
  'balances',
  'positions',
  'orders',
  'conditionalOrders',
  'trackerAssets',
  // 'history',
] as const;

export { tabNames };
